import { render, staticRenderFns } from "./SiteTemplate.vue?vue&type=template&id=b3242340&"
import script from "./SiteTemplate.vue?vue&type=script&lang=js&"
export * from "./SiteTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SiteTemplate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SiteTemplate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports